// import selectIcon from '@/assets/icons/UI/DownSquare.svg?raw'

export const selectConfig = () => {
  return {
    root: {
      dropdownWidth: '3.2rem',
      optionColor: 'var(--site-text)',
      optionFocusColor: 'var(--site-text)',
      optionSelectedColor: 'var(--site-text)',
      optionSelectedFocusColor: 'var(--site-text)',
      optionSelectedBackground: 'var(--primary-200)',
      optionSelectedFocusBackground: 'var(--primary-200)'
    }
  }
}

export const selectPt = () => {
  return {
    label: {
      class: 'font-14-n'
    },
    // dropdown: {
    //   innerHTML: selectIcon
    // },
    clearIcon: {
      style: 'width: 1.4em; height: 1.4em; transform: translateY(-50%); margin: 0'
    },
    optionLabel: 'font-14-n',
    pcFilter: {
      root: 'p-inputtext-sm p-inputfield-sm font-12-n'
    }
  }
}
